import { tns } from 'tiny-slider/src/tiny-slider'

export default () => {

	const els = [...document.querySelectorAll('.text-image.has-carousel')]
	els.map(el => {

		const carouselEl = el.querySelector('.text-image__carousel')
		const carouselNav = el.querySelector('.text-image__dots')
		if (!carouselEl || !carouselNav) return null

		return tns({
			container: carouselEl,
			items: 1,
			controls : false,
			controlsPosition: 'bottom',
			nav: true,
			navContainer: carouselNav,
			touch: true,
			mouseDrag: true,
			loop: true,
			autoplay: true,
			speed: 700,
			autoplayTimeout: 7000,
			autoplayButtonOutput: false,
			useLocalStorage: false,
		})
	})
}


